import { render } from "./ParagraphAction.vue?vue&type=template&id=74c8beae"
import script from "./ParagraphAction.vue?vue&type=script&lang=js"
export * from "./ParagraphAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__